export enum Leistungseinheit {
    KW = 'KW',
    MW = 'MW'
}
